<template>
  <ontick-aero :active="active" @close="$emit('close')">
    <div v-show="active" class="w-screen max-w-3xl">
      <div class="glass-carbon flex h-full flex-col overflow-y-scroll shadow-xl">
        <div class="glass-carbon sticky top-0 z-10 px-6 py-3 shadow-lg">
          <div class="flex items-center space-x-2">
            <button
              @click="$emit('close')"
              class="text-ontick-carbon-900 px-1 py-1 hover:text-gray-400 focus:outline-none dark:text-gray-400"
            >
              <span v-html="$icons.arrow_left" />
            </button>

            <h2 class="text-ontick-steel-900 py-2 font-medium dark:text-gray-300">Investimentos arquivados</h2>
          </div>
        </div>

        <div v-if="strategies.length > 0" class="mt-2 px-6">
          <div class="grid grid-cols-1 gap-4 pb-16 md:grid-cols-2">
            <div class="relative" v-for="item in strategies" :key="item.investment_id">
              <card-strategy class="card-investment transition-card" :item="item" :setVolume="false"></card-strategy>
              <!-- <card-strategy
                v-if="item.type == 'STRATEGY' || item.type == 'SIGNAL'"
                class="card-investment transition-card"
                :item="item"
                :setVolume="false"
              ></card-strategy> -->
              <!-- <card-portfolio-stopped
                v-if="item.type == 'PORTFOLIO'"
                class="card-investment transition-card"
                :item="item"
              ></card-portfolio-stopped> -->
            </div>
          </div>
        </div>
        <div v-if="strategies.length == 0" class="flex h-full items-center px-6">
          <div class="flex-1">
            <h2 class="text-ontick-carbon-400 text-lg font-semibold dark:text-gray-400 md:text-2xl">
              Nenhum investimento arquivado.
            </h2>
            <p class="text-ontick-carbon-400 py-6 text-xs dark:text-gray-400 md:text-sm">Sem itens arquivados.</p>
          </div>
          <div class="w-5/12 max-w-md px-6">
            <span v-html="filed"></span>
          </div>
        </div>
      </div>
    </div>
  </ontick-aero>
</template>

<script>
import { filed } from "@/app/assets/icons/isometric.js";
import { mapGetters } from "vuex";
import event_bus from "../../../../../shared/utils/event_bus";
export default {
  components: {
    CardStrategy: () => import("../card-investment/card-strategy/card-strategy.component.vue"),
    // CardPortfolioStopped: () =>
    //   import(
    //     "../card-investment/card-portfolio/card-portfolio-stopped.component.vue"
    //   ),
  },

  props: {
    active: { type: Boolean, default: false },
    // strategies: { type: Array, default: [] },
  },

  data() {
    return {
      filed: filed,
      strategies: [],
      loading: false,
    };
  },

  computed: {
    ...mapGetters({ getSelectedAccount: "accountTypes/getSelectedAccount" }),
  },

  methods: {
    async getInvestments() {
      this.loading = true;
      try {
        const { data } = await this.$api.get(
          this.$endpoint.GET_INVESTMENTS + "/" + this.getSelectedAccount.account_id,
          {
            params: {
              exec_status: "HIDDEN",
            },
          }
        );
        this.strategies = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
  },

  watch: {
    active: {
      handler(val) {
        if (val) {
          this.getInvestments();
        }
      },
    },
  },

  mounted() {
    event_bus.$on("RELOAD_HIDDEN", () => {
      this.getInvestments();
    });
  },
};
</script>

<style lang="scss" scoped>
.card-investment {
  @apply border-ontick-steel-300 dark:bg-ontick-graphite-500 relative h-full w-full overflow-hidden rounded-lg border-2 bg-gray-50 shadow dark:border-none;
}
</style>
